import { adminApi } from '~/api'
import { useQuery } from '@tanstack/react-query'

export const courseParticipantsQueryKey = (id) => ['courses', id, 'students']

export const useCourseParticipantsQuery = (id) =>
  useQuery({
    queryKey: courseParticipantsQueryKey(id),
    queryFn: async () => {
      const { data } = await adminApi.getCourseParticipants(id)
      return data.data
    }
  })

export const useCourseServersQuery = (courseId) =>
  useQuery({
    queryKey: ['courses', courseId, 'servers'],
    queryFn: async () => {
      const { data } = await adminApi.getCourseServers(courseId)
      return data.data
    },
    initialData: []
  })

export const useCourseQuery = (id) =>
  useQuery({
    queryKey: ['courses', id],
    queryFn: async () => {
      const { data } = await adminApi.getCourse(id)
      return data.data
    }
  })
